import React from "react";
import "./brandLogos.scss";

const BrandLogo = () => {
  const logos = [
    { id: 1, src: "reliancecap.png", alt: "Company 1" },
    { id: 2, src: "brand2.png", alt: "Company 2" },
    { id: 3, src: "brand3.png", alt: "Company 3" },
    { id: 4, src: "brand4.png", alt: "Company 4" },
    { id: 5, src: "brand5.png", alt: "Company 5" },
    { id: 6, src: "brand6.png", alt: "Company 6" },
    { id: 7, src: "brand7.png", alt: "Company 7" },
    { id: 8, src: "thesurya.jpeg", alt: "Company 8" },
    
    
  ];

  return (
    <div className="brand-logos">
      <div className="container">
        <h2 className="brand-logos__title">Our Clients</h2>
        <div className="brand-logos__grid">
          {logos.map((logo) => (
            <div key={logo.id} className="brand-logos__item">
              <img
                src={logo.src}
                alt={logo.alt}
                className="brand-logos__image"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BrandLogo;
